import React, {useEffect, useState} from 'react';
import Layout from './layout';
import './scss/deposit.scss';
import StatusView from './status-view';
import DepositTransactions from './deposit-transactions';
import DepositForm from './deposit-form';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function Deposit(): React.ReactElement {
    const [statusMessage, setStatusMessage] = useState({message: '', type: StatusMessageTypeEnum.none});

    const urlParams = new URLSearchParams(window.location.search);
    const action = String(urlParams.get('action'));
    let view = <div/>;

    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };

    if (action === 'start') {
        view = (
            <div>
                <div className="banner"/>
                <DepositForm setStatusMessage={onStatusMessage}/>
            </div>
        );
    } else {
        view = (
            <DepositTransactions setStatusMessage={onStatusMessage}/>
        );
    }

    useEffect(() => {

    }, []);

    return (
        <Layout className="page deposit ">
            <StatusView status={statusMessage}/>
            {view}
            <div/>
        </Layout>
    );
}

export default Deposit;
